import { render, staticRenderFns } from "./OddSalesComponent.vue?vue&type=template&id=d9a2587c&scoped=true&"
import script from "./OddSalesComponent.vue?vue&type=script&lang=ts&"
export * from "./OddSalesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OddSalesComponent.vue?vue&type=style&index=0&id=d9a2587c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a2587c",
  null
  
)

export default component.exports